export const iconFile = 'fas fa-file text-dark fa-fw'
export const iconLoading = 'fas fa-spin fa-spinner text-dark fa-fw'
export const iconSuccess = 'fas fa-check text-success fa-fw'
export const iconError = 'fas fa-exclamation-triangle text-warning fa-fw'
export const iconTrash = 'fas text-danger fa-trash fa-fw'